export const SidePanelSubmittalsEndPoints = {
  procurementLogReadSpecificSubmittalSidePanel: {
    url: (company, id, entryID) =>
      `/rest/v1/procurementLogReadSpecificSubmittalSidePanel/${company}/${id}/${entryID}`,
    method: "GET",
  },
  // procurementLogContractorEditEntry: {
  //   url: (company, id) =>
  //     `/rest/v1/procurementLogContractorEditEntry/${company}/${id}`,
  //   method: "PUT",
  // },
};
